/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {Forecast} from '../bioplanModels';
// @ts-ignore
import type {GrowthPerCage} from '../bioplanModels';
// @ts-ignore
import type {MortalityPerCage} from '../bioplanModels';
// @ts-ignore
import type {QualityForecast} from '../bioplanModels';
// @ts-ignore
import type {SiteStatus} from '../bioplanModels';
/**
 * PlanningForecastApi - axios parameter creator
 * @export
 */
export const PlanningForecastApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get quality forecast for a cage.
     * @param {string} cageId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastCageIdQualityForecastGet: async (
      cageId: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('forecastCageIdQualityForecastGet', 'cageId', cageId);
      const localVarPath = `/forecast/{cageId}/qualityForecast`.replace(
        `{${'cageId'}}`,
        encodeURIComponent(String(cageId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Forecast count, weight, and/or biomass data for cages, sites, and plans.
     * @param {Array<string>} [cageId]
     * @param {Array<string>} [siteId]
     * @param {Array<string>} [planId]
     * @param {Array<ForecastGetColumnsEnum>} [columns]
     * @param {ForecastGetGroupByEnum} [groupBy]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastGet: async (
      cageId?: Array<string>,
      siteId?: Array<string>,
      planId?: Array<string>,
      columns?: Array<ForecastGetColumnsEnum>,
      groupBy?: ForecastGetGroupByEnum,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/forecast`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (cageId) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (siteId) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (planId) {
        localVarQueryParameter['planId'] = planId;
      }

      if (columns) {
        localVarQueryParameter['columns'] = columns;
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastGrowthPerCagePlanIdGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('forecastGrowthPerCagePlanIdGet', 'planId', planId);
      const localVarPath = `/forecast/growthPerCage/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastMortalityPerCagePlanIdGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('forecastMortalityPerCagePlanIdGet', 'planId', planId);
      const localVarPath = `/forecast/mortalityPerCage/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastSiteStatusSiteIdGet: async (siteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('forecastSiteStatusSiteIdGet', 'siteId', siteId);
      const localVarPath = `/forecast/siteStatus/{siteId}`.replace(`{${'siteId'}}`, encodeURIComponent(String(siteId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningForecastApi - functional programming interface
 * @export
 */
export const PlanningForecastApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningForecastApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get quality forecast for a cage.
     * @param {string} cageId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forecastCageIdQualityForecastGet(
      cageId: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualityForecast>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.forecastCageIdQualityForecastGet(
        cageId,
        startDate,
        endDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningForecastApi.forecastCageIdQualityForecastGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Forecast count, weight, and/or biomass data for cages, sites, and plans.
     * @param {Array<string>} [cageId]
     * @param {Array<string>} [siteId]
     * @param {Array<string>} [planId]
     * @param {Array<ForecastGetColumnsEnum>} [columns]
     * @param {ForecastGetGroupByEnum} [groupBy]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forecastGet(
      cageId?: Array<string>,
      siteId?: Array<string>,
      planId?: Array<string>,
      columns?: Array<ForecastGetColumnsEnum>,
      groupBy?: ForecastGetGroupByEnum,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Forecast>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.forecastGet(
        cageId,
        siteId,
        planId,
        columns,
        groupBy,
        startDate,
        endDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningForecastApi.forecastGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forecastGrowthPerCagePlanIdGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrowthPerCage>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.forecastGrowthPerCagePlanIdGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningForecastApi.forecastGrowthPerCagePlanIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forecastMortalityPerCagePlanIdGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MortalityPerCage>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.forecastMortalityPerCagePlanIdGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningForecastApi.forecastMortalityPerCagePlanIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forecastSiteStatusSiteIdGet(
      siteId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteStatus>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.forecastSiteStatusSiteIdGet(siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningForecastApi.forecastSiteStatusSiteIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningForecastApi - factory interface
 * @export
 */
export const PlanningForecastApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningForecastApiFp(configuration);
  return {
    /**
     *
     * @summary Get quality forecast for a cage.
     * @param {PlanningForecastApiForecastCageIdQualityForecastGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastCageIdQualityForecastGet(
      requestParameters: PlanningForecastApiForecastCageIdQualityForecastGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QualityForecast> {
      return localVarFp
        .forecastCageIdQualityForecastGet(
          requestParameters.cageId,
          requestParameters.startDate,
          requestParameters.endDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Forecast count, weight, and/or biomass data for cages, sites, and plans.
     * @param {PlanningForecastApiForecastGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastGet(
      requestParameters: PlanningForecastApiForecastGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Forecast> {
      return localVarFp
        .forecastGet(
          requestParameters.cageId,
          requestParameters.siteId,
          requestParameters.planId,
          requestParameters.columns,
          requestParameters.groupBy,
          requestParameters.startDate,
          requestParameters.endDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PlanningForecastApiForecastGrowthPerCagePlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastGrowthPerCagePlanIdGet(
      requestParameters: PlanningForecastApiForecastGrowthPerCagePlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GrowthPerCage> {
      return localVarFp
        .forecastGrowthPerCagePlanIdGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PlanningForecastApiForecastMortalityPerCagePlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastMortalityPerCagePlanIdGet(
      requestParameters: PlanningForecastApiForecastMortalityPerCagePlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MortalityPerCage> {
      return localVarFp
        .forecastMortalityPerCagePlanIdGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PlanningForecastApiForecastSiteStatusSiteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastSiteStatusSiteIdGet(
      requestParameters: PlanningForecastApiForecastSiteStatusSiteIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SiteStatus> {
      return localVarFp
        .forecastSiteStatusSiteIdGet(requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for forecastCageIdQualityForecastGet operation in PlanningForecastApi.
 * @export
 * @interface PlanningForecastApiForecastCageIdQualityForecastGetRequest
 */
export interface PlanningForecastApiForecastCageIdQualityForecastGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningForecastApiForecastCageIdQualityForecastGet
   */
  readonly cageId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningForecastApiForecastCageIdQualityForecastGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningForecastApiForecastCageIdQualityForecastGet
   */
  readonly endDate?: string;
}

/**
 * Request parameters for forecastGet operation in PlanningForecastApi.
 * @export
 * @interface PlanningForecastApiForecastGetRequest
 */
export interface PlanningForecastApiForecastGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof PlanningForecastApiForecastGet
   */
  readonly cageId?: Array<string>;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningForecastApiForecastGet
   */
  readonly siteId?: Array<string>;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningForecastApiForecastGet
   */
  readonly planId?: Array<string>;

  /**
   *
   * @type {Array<'biomass' | 'count' | 'weight' | 'feedAmount' | 'biomassSalmon' | 'biomassTrout' | 'countSalmon' | 'countTrout' | 'producedBiomass'>}
   * @memberof PlanningForecastApiForecastGet
   */
  readonly columns?: Array<ForecastGetColumnsEnum>;

  /**
   *
   * @type {'day' | 'week' | 'month' | 'year'}
   * @memberof PlanningForecastApiForecastGet
   */
  readonly groupBy?: ForecastGetGroupByEnum;

  /**
   *
   * @type {string}
   * @memberof PlanningForecastApiForecastGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningForecastApiForecastGet
   */
  readonly endDate?: string;
}

/**
 * Request parameters for forecastGrowthPerCagePlanIdGet operation in PlanningForecastApi.
 * @export
 * @interface PlanningForecastApiForecastGrowthPerCagePlanIdGetRequest
 */
export interface PlanningForecastApiForecastGrowthPerCagePlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningForecastApiForecastGrowthPerCagePlanIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for forecastMortalityPerCagePlanIdGet operation in PlanningForecastApi.
 * @export
 * @interface PlanningForecastApiForecastMortalityPerCagePlanIdGetRequest
 */
export interface PlanningForecastApiForecastMortalityPerCagePlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningForecastApiForecastMortalityPerCagePlanIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for forecastSiteStatusSiteIdGet operation in PlanningForecastApi.
 * @export
 * @interface PlanningForecastApiForecastSiteStatusSiteIdGetRequest
 */
export interface PlanningForecastApiForecastSiteStatusSiteIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningForecastApiForecastSiteStatusSiteIdGet
   */
  readonly siteId: string;
}

/**
 * PlanningForecastApi - object-oriented interface
 * @export
 * @class PlanningForecastApi
 * @extends {BaseAPI}
 */
export class PlanningForecastApi extends BaseAPI {
  /**
   *
   * @summary Get quality forecast for a cage.
   * @param {PlanningForecastApiForecastCageIdQualityForecastGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningForecastApi
   */
  public forecastCageIdQualityForecastGet(
    requestParameters: PlanningForecastApiForecastCageIdQualityForecastGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningForecastApiFp(this.configuration)
      .forecastCageIdQualityForecastGet(
        requestParameters.cageId,
        requestParameters.startDate,
        requestParameters.endDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Forecast count, weight, and/or biomass data for cages, sites, and plans.
   * @param {PlanningForecastApiForecastGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningForecastApi
   */
  public forecastGet(requestParameters: PlanningForecastApiForecastGetRequest = {}, options?: RawAxiosRequestConfig) {
    return PlanningForecastApiFp(this.configuration)
      .forecastGet(
        requestParameters.cageId,
        requestParameters.siteId,
        requestParameters.planId,
        requestParameters.columns,
        requestParameters.groupBy,
        requestParameters.startDate,
        requestParameters.endDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PlanningForecastApiForecastGrowthPerCagePlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningForecastApi
   */
  public forecastGrowthPerCagePlanIdGet(
    requestParameters: PlanningForecastApiForecastGrowthPerCagePlanIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningForecastApiFp(this.configuration)
      .forecastGrowthPerCagePlanIdGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PlanningForecastApiForecastMortalityPerCagePlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningForecastApi
   */
  public forecastMortalityPerCagePlanIdGet(
    requestParameters: PlanningForecastApiForecastMortalityPerCagePlanIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningForecastApiFp(this.configuration)
      .forecastMortalityPerCagePlanIdGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PlanningForecastApiForecastSiteStatusSiteIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningForecastApi
   */
  public forecastSiteStatusSiteIdGet(
    requestParameters: PlanningForecastApiForecastSiteStatusSiteIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningForecastApiFp(this.configuration)
      .forecastSiteStatusSiteIdGet(requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const ForecastGetColumnsEnum = {
  Biomass: 'biomass',
  Count: 'count',
  Weight: 'weight',
  FeedAmount: 'feedAmount',
  BiomassSalmon: 'biomassSalmon',
  BiomassTrout: 'biomassTrout',
  CountSalmon: 'countSalmon',
  CountTrout: 'countTrout',
  ProducedBiomass: 'producedBiomass',
} as const;
export type ForecastGetColumnsEnum = (typeof ForecastGetColumnsEnum)[keyof typeof ForecastGetColumnsEnum];
/**
 * @export
 */
export const ForecastGetGroupByEnum = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Year: 'year',
} as const;
export type ForecastGetGroupByEnum = (typeof ForecastGetGroupByEnum)[keyof typeof ForecastGetGroupByEnum];
